import { render, staticRenderFns } from "./PercentGauge.vue?vue&type=template&id=5e2487a2&scoped=true&class=chart&"
import script from "./PercentGauge.vue?vue&type=script&lang=js&"
export * from "./PercentGauge.vue?vue&type=script&lang=js&"
import style0 from "./PercentGauge.vue?vue&type=style&index=0&id=5e2487a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2487a2",
  null
  
)

export default component.exports